import React from 'react';
import { Link } from 'react-router-dom';
import { LinkedinIcon, MailIcon } from 'lucide-react';
import { Logo } from '../brand/Logo';
import { Button } from '../ui/Button';
import { HubSpotForm } from '../HubSpotForm';
import { Dialog } from '../portal/Dialog';
import { KenteRibbon } from './AfricanBackdrop';
import { SERVICE_LINES } from '../../data/services';
import { LINKEDIN_URL, CONTACT_EMAIL } from '../../lib/seo';
const COMPANY_FACTS = ['Cavalla Solution is a consulting firm in augmented intelligence, market intelligence and data led growth.'];
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
export function Footer() {
  const [email, setEmail] = React.useState('');
  const [error, setError] = React.useState<string | null>(null);
  const [open, setOpen] = React.useState(false);

  // The email opens the full HubSpot form, where the subscription is completed.
  const onSubscribe = (event: React.FormEvent) => {
    event.preventDefault();
    if (!EMAIL_PATTERN.test(email.trim())) {
      setError('Enter a valid email address.');
      return;
    }
    setError(null);
    setOpen(true);
  };
  return <footer className="surface-dark text-white" data-id="element-785" data-mp="2p4mp3ljrloyv">
      <KenteRibbon data-id="element-786" data-mp="2bcevg2ns2e4e" />
      <div className="mx-auto w-full max-w-6xl px-5 py-16 sm:px-8 sm:py-20" data-id="element-787" data-mp="2bcyc7g1oywgu">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr]" data-id="element-788" data-mp="2gbj32ov203sm">
          <div data-id="element-789" data-mp="2gbrjgqqdxr8k">
            <Logo variant="reversed" data-id="element-790" data-mp="2g9578dsjunk0" />
            <p className="mt-6 max-w-xs text-[15px] text-white/70" data-id="element-791" data-mp="340u8ijncmmd3">
              Evidence first consulting for organisations that have to make the decision, not just discuss it.
            </p>
            <div className="mt-6 flex items-center gap-4" data-id="element-792" data-mp="2u3pjmc24ccsl">
              <a href={LINKEDIN_URL} target="_blank" rel="noopener noreferrer" className="text-white/70 transition-colors hover:text-gold" aria-label="Cavalla Solution on LinkedIn, opens in a new tab" data-id="element-793" data-mp="2u5aclx8sbnoc">
                <LinkedinIcon className="h-5 w-5" aria-hidden="true" data-id="element-794" data-mp="1nkhjmbkbvm3a" />
              </a>
              <a href={`mailto:${CONTACT_EMAIL}`} className="text-white/70 transition-colors hover:text-gold" aria-label="Email Cavalla Solution" data-id="element-795" data-mp="13mu1i67en53m">
                <MailIcon className="h-5 w-5" aria-hidden="true" data-id="element-796" data-mp="uq2wv5esehxf" />
              </a>
            </div>
          </div>

          <nav aria-label="Services" data-id="element-797" data-mp="ktzx267eqvdn">
            <h2 className="text-[11px] font-semibold uppercase tracking-[0.2em] text-gold" data-id="element-798" data-mp="kv18wcw8zlwf">Services</h2>
            <ul className="mt-5 space-y-3 text-[15px] text-white/75" data-id="element-799" data-mp="fudls2b53p7h">
              {SERVICE_LINES.map(line => <li key={line.id} data-id="element-800" data-mp="bttlwqz6m7hn">
                  <Link to={`/services/${line.id}`} className="transition-colors hover:text-white" data-id="element-801" data-mp="6uqfp37gtv83">
                    {line.name}
                  </Link>
                </li>)}
              <li data-id="element-802" data-mp="218hwqns4jhdk">
                <Link to="/cavalla-gov" className="transition-colors hover:text-white" data-id="element-803" data-mp="217yipi5lhd4t">
                  Cavalla Gov
                </Link>
              </li>
              <li data-id="element-804" data-mp="28pwlz4x6nrzl">
                <Link to="/augmented-intelligence" className="transition-colors hover:text-white" data-id="element-805" data-mp="2dr3rexbusf33">
                  Our method
                </Link>
              </li>
              <li data-id="element-806" data-mp="2iilsrmhsghol">
                <Link to="/assessment" className="transition-colors hover:text-white" data-id="element-807" data-mp="2ik6h2udif4e0">
                  AI readiness assessment
                </Link>
              </li>
            </ul>
          </nav>

          <nav aria-label="Company" data-id="element-808" data-mp="1us81vzaxwovl">
            <h2 className="text-[11px] font-semibold uppercase tracking-[0.2em] text-gold" data-id="element-809" data-mp="1utaqg0ksif8c">Company</h2>
            <ul className="mt-5 space-y-3 text-[15px] text-white/75" data-id="element-810" data-mp="1zq9i8cgzea3d">
              <li data-id="element-811" data-mp="23so4z7nrttzx"><Link to="/insights" className="transition-colors hover:text-white" data-id="element-812" data-mp="23tfm5dgmfp6o">Insights</Link></li>
              <li data-id="element-813" data-mp="3b70y1hb4blmq"><Link to="/webinars" className="transition-colors hover:text-white" data-id="element-814" data-mp="3b70zllqrntou">Webinars</Link></li>
              <li data-id="element-815" data-mp="3f7be5msmjsfb"><Link to="/careers" className="transition-colors hover:text-white" data-id="element-816" data-mp="3f7bclicz7kd7">Careers</Link></li>
              <li data-id="element-817" data-mp="3dq4c9ke5bfoy"><Link to="/resources" className="transition-colors hover:text-white" data-id="element-818" data-mp="3drywewhlf3rz">Resources</Link></li>
              <li data-id="element-819" data-mp="38sw143rf0bx7"><Link to="/about" className="transition-colors hover:text-white" data-id="element-820" data-mp="38svzjzbro3v3">About</Link></li>
              <li data-id="element-821" data-mp="3nq4ut446xrs3"><Link to="/contact" className="transition-colors hover:text-white" data-id="element-822" data-mp="3npv5liqyzong">Contact</Link></li>
              <li data-id="element-823" data-mp="3ip7g51ie3fvc"><Link to="/portal/login" className="transition-colors hover:text-white" data-id="element-824" data-mp="3ip7hp5y1fnxg">Client login</Link></li>
            </ul>
          </nav>

          <div data-id="element-825" data-mp="i1ai2tn9sby">
            <h2 className="text-[11px] font-semibold uppercase tracking-[0.2em] text-gold" data-id="element-826" data-mp="3rqyipxhmv6kz">Fortnightly brief</h2>
            <p className="mt-5 text-[15px] text-white/70" data-id="element-827" data-mp="aagpcr9na0sm">
              One email every two weeks. Market movement, AI adoption and what it means for your sector.
            </p>
            <form onSubmit={onSubscribe} noValidate className="mt-5" data-id="element-828" data-mp="jalxx4qkr58d">
              <label htmlFor="footer-email" className="sr-only" data-id="element-829" data-mp="j8spbjweiaxq">
                Your email address
              </label>
              <div className="flex flex-col gap-2 sm:flex-row" data-id="element-830" data-mp="xxkkalakr9g8">
                <input id="footer-email" type="email" required value={email} onChange={event => {
                setEmail(event.target.value);
                if (error) setError(null);
              }} placeholder="you@organisation.org" aria-invalid={Boolean(error)} aria-describedby={error ? 'footer-email-error' : undefined} className="w-full rounded-sm border border-white/25 bg-white/5 px-3 py-2.5 text-[15px] text-white placeholder:text-white/40" data-id="element-831" data-mp="xydk12b48yov" />
                <Button type="submit" size="sm" className="shrink-0" data-id="element-832" data-mp="a7q885y2xox1">
                  Subscribe
                </Button>
              </div>
              {error && <p id="footer-email-error" role="alert" className="mt-2 text-small text-gold" data-id="element-833" data-mp="3sfyxcrhticmb">
                  {error}
                </p>}
              <p className="mt-3 text-small text-white/50" data-id="element-834" data-mp="22xisdzcqhuag">
                We handle your data in line with our{' '}
                <Link to="/legal/privacy" className="underline underline-offset-2 hover:text-white" data-id="element-835" data-mp="1y47nw4ve9plp">
                  privacy notice
                </Link>
                .
              </p>
            </form>
            <Dialog open={open} onClose={() => setOpen(false)} title="Complete your subscription" description={`A few details so the brief fits your work. Use ${email.trim()} in the email field.`} data-id="element-836" data-mp="1p6x6s2vwb68v">
              <HubSpotForm portalId="149348668" formId="7ef7b25d-42ed-4c7e-b9af-1667782abdf4" region="eu1" className="rounded-md bg-white p-4" data-id="element-837" data-mp="2ctlxne2vu91m" />
            </Dialog>
          </div>
        </div>

        <div className="mt-14 border-t border-white/12 pt-8" data-id="element-838" data-mp="wfvq1xck12n8">
          <h2 className="text-[11px] font-semibold uppercase tracking-[0.2em] text-white/40" data-id="element-839" data-mp="wihydz79rm6i">
            About Cavalla Solution
          </h2>
          <ul className="mt-3 space-y-1.5 text-small text-white/45" data-id="element-840" data-mp="rb1l36rfkpp2">
            {COMPANY_FACTS.map(fact => <li key={fact} data-id="element-841" data-mp="w9motg5w5ri9">{fact}</li>)}
          </ul>
        </div>

        <div className="mt-8 flex flex-col gap-4 border-t border-white/12 pt-8 text-small text-white/50 sm:flex-row sm:items-center sm:justify-between" data-id="element-842" data-mp="111w8iegexvc3">
          <p data-id="element-843" data-mp="1552fxpf9hsk5">Copyright {new Date().getFullYear()} Cavalla Solution. All rights reserved.</p>
          <nav aria-label="Legal" className="flex flex-wrap gap-5" data-id="element-844" data-mp="1a0812m0ub376">
            <Link to="/legal/privacy" className="hover:text-white" data-id="element-845" data-mp="1f274fvwky044">Privacy</Link>
            <Link to="/legal/terms" className="hover:text-white" data-id="element-846" data-mp="1k0s1xnkg65ov">Terms</Link>
            <Link to="/legal/cookies" className="hover:text-white" data-id="element-847" data-mp="3gsil1esitp0i">Cookies</Link>
          </nav>
        </div>
      </div>
    </footer>;
}